import { useCallback, useMemo, useState } from 'react';

import type { NovaNavigation, NovaView } from './types';

/** Deliberately has no browser history integration: embeds must never mutate host history. */
export function useMemoryNovaNavigation(initialView: NovaView = { kind: 'chat' }): NovaNavigation {
  const [view, setView] = useState(initialView);
  const navigate = useCallback<NovaNavigation['navigate']>((nextView) => setView(nextView), []);
  return useMemo(() => ({ view, navigate }), [view, navigate]);
}
